import { Modal, Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import React, { useState, useEffect } from "react";

export default function FilterModal({
  show,
  onHide,
  statusFilter,
  setStatusFilter,
  vehicleCompanyFilter,
  setVehicleCompanyFilter,
  monthFilter,
  setMonthFilter,
  hubFilter,
  setHubFilter,
  ticketCategoryFilter,
  setTicketCategoryFilter,
  ticketAgingFilter,
  setTicketAgingFilter,
  leasingPartnerFilter,
  setLeasingPartnerFilter,
  leasingPartners,
  applyFilters,
  removeFilters,
  // apidata,
  hubs,
  vehicleTypes,
}) {
  const [hubSearch, setHubSearch] = useState("");

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="statusFilter">
            <Form.Label>Status</Form.Label>
            <Form.Control
              as="select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
              <option value="Unassigned">Unassigned</option>
              <option value="Service_Center">Service_Center</option>
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="hubFilter" className="mt-3">
            <Form.Label>Hubs</Form.Label>

            {/* 🔍 Search Box */}
            <Form.Control
              type="text"
              placeholder="Search hub..."
              value={hubSearch}
              onChange={(e) => setHubSearch(e.target.value)}
              className="mb-2"
            />

            <div
              className="border rounded p-2"
              style={{ maxHeight: "150px", overflowY: "auto" }}
            >
              {hubs
                // ✅ ONLY ACTIVE HUBS
                .filter((hub) => hub.status === "Active")

                // 🔍 SEARCH
                .filter((hub) =>
                  hub.name.toLowerCase().includes(hubSearch.toLowerCase()),
                )

                // 🔤 SORT
                .sort((a, b) => a.name.localeCompare(b.name))

                .map((hub) => (
                  <Form.Check
                    key={hub._id}
                    type="checkbox"
                    label={hub.name}
                    value={hub._id}
                    checked={hubFilter.includes(hub._id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setHubFilter([...hubFilter, hub._id]);
                      } else {
                        setHubFilter(hubFilter.filter((h) => h !== hub._id));
                      }
                    }}
                    className="mb-1"
                  />
                ))}
            </div>
          </Form.Group>

          <Form.Group controlId="vehicleCompanyFilter">
            <Form.Label>Vehicle Company</Form.Label>
            <Form.Control
              as="select"
              value={vehicleCompanyFilter}
              onChange={(e) => setVehicleCompanyFilter(e.target.value)}
            >
              <option value="">All Vehicle Companies</option>

              {vehicleTypes.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.company}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="monthFilter">
            <Form.Label>Onboarding Month</Form.Label>
            <div>
              <DatePicker
                selected={
                  monthFilter
                    ? new Date(
                        monthFilter.split("/")[1],
                        monthFilter.split("/")[0] - 1,
                      )
                    : null
                }
                onChange={(date) => {
                  if (!date) {
                    setMonthFilter("");
                    return;
                  }

                  const month = String(date.getMonth() + 1).padStart(2, "0");
                  const year = date.getFullYear();

                  setMonthFilter(`${month}/${year}`); // 🔥 backend format
                }}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                placeholderText="📅 Select Month & Year"
                className="form-control"
                wrapperClassName="d-block"
              />
            </div>
          </Form.Group>

          <Form.Group controlId="leasingPartnerFilter" className="mt-3">
            <Form.Label>Leasing Partner</Form.Label>

            <Form.Control
              as="select"
              value={leasingPartnerFilter}
              onChange={(e) => setLeasingPartnerFilter(e.target.value)}
            >
              <option value="">All Leasing Partners</option>

              {leasingPartners.map((partner) => (
                <option key={partner} value={partner}>
                  {partner}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="ticketCategoryFilter" className="mt-3">
            <Form.Label>Ticket Category</Form.Label>

            <Form.Control
              as="select"
              value={ticketCategoryFilter}
              onChange={(e) => setTicketCategoryFilter(e.target.value)}
            >
              <option value="">All Categories</option>
              <option value="Service">Service</option>
              <option value="Insurance">Insurance</option>
              <option value="Accident">Accident</option>
              <option value="Other">Other</option>
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="ticketAgingFilter" className="mt-3">
            <Form.Label>Ticket Aging</Form.Label>

            <Form.Control
              as="select"
              value={ticketAgingFilter}
              onChange={(e) => setTicketAgingFilter(e.target.value)}
            >
              <option value="">All Aging</option>
              <option value="0-3">0 - 3 Days</option>
              <option value="4-7">4 - 7 Days</option>
              <option value="8-15">8 - 15 Days</option>
              <option value="16-30">16 - 30 Days</option>
              <option value="31+">31+ Days</option>
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
